export const SET_SCENARIOS = 'SET_SCENARIOS';